import { usePetitionCommentPageData } from '#src/app/pages/petitionComment/pageContext';
import type { ShareAction, ShareChannel } from '#src/app/shared/hooks/share';
import { useShareActions } from '#src/app/shared/hooks/share';

import type { PartialComment, PartialPetition, ShareConfig } from '../types';

import { useCommentShareOptions } from './options';

export function useCommentAvailableShareActions(
	comment: PartialComment,
	petition: PartialPetition,
	config: ShareConfig,
): ReadonlyArray<ShareAction<ShareChannel>> {
	const {
		data: { comment: pageComment },
	} = usePetitionCommentPageData();

	const shareLinks = 'shareLinks' in pageComment ? pageComment.shareLinks : undefined;

	const options = useCommentShareOptions(comment, petition, config);

	return useShareActions(shareLinks?.links ?? [], options);
}
